import { AxiosResponse, AxiosError } from "axios";
import { prepareError } from "../../../utils/error";
import api from "../../../data/api";
import { OptionCl } from "../../../components/select-cl";
import { Dispatch } from "redux";


export const COUNTRY_DOMAIN = "CTRY"

export type Country = {    
    ctry: string
}

const prepareCountries  = ( response : Country[]   ) => {
    const opts: OptionCl[] = response.map( (ctry : Country) => ({
        id : ctry.ctry,
        description: ctry.ctry
    })
    )
    return opts;
}


// countries for the dropdown
export const fetchCountries = (
    dispatch : Dispatch<any>,
    componentType: "CcbCriteria" 
) => {
    //console.log("ismag criteria service getting data from /countries")
    api
        .post("/codelist/v1/ccb/countries")
        .then( (response:AxiosResponse) => {

            if (response.data && response.data.result === "ERROR") {
                dispatch({ type: componentType + "/FETCHERROR", payload: prepareError(response.data) })
            } else { 
                //console.log("country domain service: got data " + JSON.stringify(response))
                const countries : Country[] = response.data.CCB; 
                dispatch({type: componentType + "/DOMAINLOADED", payload: prepareCountries(countries), domain: COUNTRY_DOMAIN })
            }
        }).catch( (error:AxiosError) => {
            dispatch({ type: componentType + "/FETCHERROR", payload: prepareError(error) })
        })

}
